<div class="flex">

  <div class="flex flex-col">
    <div *ngIf="index !== 0" class="flex top justify-between">
      <div class="flex-1 history-box-line-left"></div>
      <div class="flex-1 history-box-line-right"></div>
    </div>
    <div *ngIf="index === 0" style="height: 1rem;"></div>
    <div class="event-box opaque-grey-border">
      <mat-icon [svgIcon]="icon"></mat-icon>
      <div class="small light" style="margin-top: 0.5rem">{{date | date: 'dd/MM/yyyy'}}</div>
    </div>
    <div *ngIf="index !== length - 1" class="flex flex-1 bottom justify-between">
      <div class="flex-1 history-box-line-left"></div>
      <div class="flex-1 history-box-line-right"></div>
    </div>
  </div>



  <div class="flex-1" style="padding: 0.5rem;">
    <div class="flex" style="padding: 0.5rem;">
      <div class="flex-1">
        <div class="mid small">Stato</div>
        <div class="small light">{{subject}}</div>
      </div>
      <div class="flex-1">
        <div class="mid small">Utente</div>
        <div class="small light">{{user}}</div>
      </div>
    </div>

    <div class="flex" style="padding: 0.5rem;">
      <div class="flex-1">
        <div class="mid small">Ruolo</div>
        <div class="small light">{{role}}</div>
      </div>
      <div class="flex-1">
        <div class="mid small">Canale</div>
        <div class="small light">{{channel}}</div>
      </div>
    </div>

    <div class="flex" style="padding: 0.5rem;">
      <div class="flex-1">
        <div class="mid small">Descrizione</div>
        <div class="small light">{{description}}</div>
      </div>

    </div>


  </div>
</div>